import React, { useState, useCallback, useEffect } from 'react';
import { strings } from 'src/localization';
import { ComponentMapIds } from '../map';
import css from './ChangePassword.module.scss';
import { Customer } from 'src/models/Customer/Customer';
import Footer from '../Footer/Footer';
import { IView } from '@framework-controls/core';
import { ascCtaInteraction, ascPageview } from 'src/helpers/EventHelper/EventHelper';
import { VehicleRec, ascCtaInteractionInput, ascPageviewInput } from 'src/models';

export interface IProps {
    custInfo?: Customer;
    profileNum: string;
    store: string;
    branch: string;
    mainPaneViewOrder: IView[];
    vehicles: VehicleRec[];
    selectedVehicle?: string;
    theme: string;
    locale: string;
    identityVerified: boolean;
    sendResetEmail: (email: string, nameId: string, profile: string, store: string, branch: string) => void;
    popFromMainPane: (id: string) => void;
    clearCustInfo: () => void;
    clearVehicles: () => void;
    clearNewVehicle: () => void;
    clearApptState: () => void;
    clearROState: () => void;
    clearROHistory: () => void;
    clearMenusState: () => void;
    waitForLogOff: () => void;
    logCustOff: () => void;
    addLogEntry: (action: string, screen: string, details: string) => void;
    clearMainPanes: () => void;
    pushToMainPanes: (inputView: IView) => void;
}

const ChangePassword = (props: IProps) => {
    const [resetClicked, setResetClicked] = useState(false);

    const clickedMessage = strings.formatString(strings.ResetPassEmailSent, props.custInfo!.emailAddress).toString();

    useEffect(() => {
        if (props.locale === 'xx') {
            // setForgotCSS(css.passLitAccess);

        }
    }, [props.locale]);

    useEffect(() => {
        props.addLogEntry('Screen Entry', 'Change Password', '');
    }, [
        props.addLogEntry,
    ]);

    const resetHandler = useCallback((e: any) => {
        setResetClicked(true);
        if (props.custInfo) {
            props.sendResetEmail(props.custInfo?.emailAddress, props.custInfo?.nameId, props.profileNum, props.store, props.branch);
        }
        const ascCtaInteractionInp : ascCtaInteractionInput = {
            pageType: 'service',
            elementText: strings.ResetPass,
            elementColor: '',
            elementOrder: '',
            elementType: 'popup',
            elementSubType: 'other_buttons',
            eventAction: 'click',
            eventActionResult: 'next_step',
            linkUrl: '',
        };
        ascCtaInteraction(ascCtaInteractionInp, e, props.vehicles, props.selectedVehicle);
    }, [props?.branch,
        props?.custInfo,
        props?.profileNum,
        props?.sendResetEmail,
        props?.store,
        props.vehicles,
        props.selectedVehicle]);

    const goToLoginHandler = useCallback((e: any) => {
        setResetClicked(false);
        // props.popFromMainPane(ComponentMapIds.UserAccountMenu);
        // props.popFromMainPane(ComponentMapIds.ChangePassword);
        // props.popFromMainPane(ComponentMapIds.ResetPassword);
        props.clearMainPanes();
        props.pushToMainPanes({
            viewId: ComponentMapIds.LandingPage,
            component: ComponentMapIds.LandingPage,
        });
        props.pushToMainPanes({
            viewId: ComponentMapIds.Login,
            component: ComponentMapIds.Login,
        });
        props.clearVehicles();
        props.clearApptState();
        props.clearCustInfo();
        props.clearMenusState();
        props.clearROHistory();
        props.clearROState();
        props.clearNewVehicle();
        props.waitForLogOff();
        props.logCustOff();
        const ascCtaInteractionInp : ascCtaInteractionInput = {
            pageType: 'service',
            elementText: strings.Login,
            elementColor: '',
            elementOrder: '',
            elementType: 'popup',
            elementSubType: 'nav_button',
            eventAction: 'click',
            eventActionResult: 'next_step',
            linkUrl: '',
        };
        ascCtaInteraction(ascCtaInteractionInp, e, props.vehicles, props.selectedVehicle);
    }, [props.clearMainPanes,
        props.pushToMainPanes,
        props.clearVehicles,
        props.clearApptState,
        props.clearCustInfo,
        props.clearMenusState,
        props.clearROHistory,
        props.clearROState,
        props.clearNewVehicle,
        props.waitForLogOff,
        props.logCustOff,
        props.vehicles,
        props.selectedVehicle,
    ]);

    const footer = resetClicked ?
        <Footer
            id='resetBtn'
            handler={goToLoginHandler}
            message={strings.LogIn}
            secondaryIsDisabled
            secondaryhandler={goToLoginHandler}
            theme={props.theme}
        />: <Footer
            id='resetBtn'
            handler={resetHandler}
            message={strings.ResetPass}
            secondaryIsDisabled
            secondaryhandler={resetHandler}
            isDisabled={resetClicked}
            theme={props.theme}
        />;

    useEffect(() => {
        if (props.mainPaneViewOrder){
            if (props.mainPaneViewOrder[props.mainPaneViewOrder.length - 1]?.viewId === ComponentMapIds.ChangePassword) {
                const ascPageViewInp: ascPageviewInput = {
                    pageType: 'service',
                    errorCode: '',
                    itemResults: '',
                };
                ascPageview(ascPageViewInp, props.vehicles, props.selectedVehicle);
            }
        }
    }, [props.mainPaneViewOrder, props.vehicles, props.selectedVehicle]);

    return (
        <div className={css.mainDiv}>
            <h2 className={(props.theme === 'mazda') || (props.theme === 'genesis')?
                css.statementMazda : css.statement}>
                {props.identityVerified ?
                    props.custInfo?.firstName + ',' :
                    strings.WelcomeBack}
            </h2>
            <div className={css.statement}>
                {resetClicked ? clickedMessage : strings.ClickResetPass}
            </div>
            <div>
                {footer}
            </div>
        </div>
    );
};

export default ChangePassword;